class ValidationErrorController {
  constructor() {

  }
}

export default ValidationErrorController;
